import $ from 'jquery';
import throttle from 'lodash/throttle';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import {FEATURE_SOURCE_ALL} from '../config';
import map from '../modules/map';

import getFeatureSource from '../selectors/get-feature-source';

class Map extends React.Component {
	componentDidMount() {
		this._controller = map(this.props);
		this._controller.onMount(this._targetElement);

		this._scrollHandler = throttle(
			() => {
				$(this._targetElement)
					.find('.ol-viewport')
					.css(
						'transform',
						`translate3d(0, ${($(window).scrollTop() || 0) / 2}px, 0)`
					);
			},
			100,
			{leading: false, trailing: true}
		);

		$(window).on('scroll', this._scrollHandler);
		this._scrollHandler();
	}

	shouldComponentUpdate(props) {
		this._controller?.onUpdate(this.props, props);

		// do not re-render, openlayers has control over the components content
		return false;
	}

	componentWillUnmount() {
		this._controller?.onUnmount();

		$(window).off('scroll', this._scrollHandler);
	}

	render() {
		const registerTargetElement = (c) => {
			this._targetElement = c;
		};

		return <div className="bsknacht17-map" ref={registerTargetElement} />;
	}
}

export default connect(
	(state) => ({
		featureSources: {
			[FEATURE_SOURCE_ALL]: getFeatureSource(state),
		},
	}),
)(withRouter(Map));
